import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import ProductUpdatesScheduledCalendarToggle from './ProductUpdatesScheduledCalendarToggle';
import I18n from 'I18n';
import { useRawParamsForListRolloutProductUpdates } from '../hooks/useRawParamsForListRolloutProductUpdates';
import { useSetQueryParams } from '../../app/hooks/useSetQueryParams';
import { Flex } from 'foundations-components/components/Flex';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ProductUpdatesCalendarHeader = () => {
  const {
    calendarTimestamp,
    view
  } = useRawParamsForListRolloutProductUpdates();
  const setQueryParams = useSetQueryParams();
  const displayTimestamp = calendarTimestamp ? I18n.moment(calendarTimestamp) : I18n.moment();
  const showPreviousWeek = () => {
    setQueryParams({
      calendarTimestamp: calendarTimestamp ? String(I18n.moment(calendarTimestamp).subtract(1, 'week').valueOf()) : ''
    });
  };
  const showNextWeek = () => {
    setQueryParams({
      calendarTimestamp: calendarTimestamp ? String(I18n.moment(calendarTimestamp).add(1, 'week').valueOf()) : ''
    });
  };
  const showToday = () => {
    setQueryParams({
      calendarTimestamp: String(I18n.moment().valueOf())
    });
  };
  const backButtonIsDisabled = I18n.moment(calendarTimestamp).startOf('week') <= I18n.moment().startOf('week');
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(ProductUpdatesScheduledCalendarToggle, {}), view === 'CALENDAR' && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: displayTimestamp,
          format: "MMMM Y"
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          onClick: showToday,
          marginInlineEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.today"
          })
        }), /*#__PURE__*/_jsxs(ButtonGroup, {
          children: [/*#__PURE__*/_jsx(IconButton, {
            disabled: backButtonIsDisabled,
            onClick: showPreviousWeek,
            children: /*#__PURE__*/_jsx(LeftIcon, {})
          }), /*#__PURE__*/_jsx(IconButton, {
            onClick: showNextWeek,
            children: /*#__PURE__*/_jsx(RightIcon, {})
          })]
        })]
      })]
    })]
  });
};
export default ProductUpdatesCalendarHeader;